import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
} from '@material-ui/core';
import { FormattedNumber, FormattedDate } from 'react-intl';
import ModalImage from 'react-modal-image';
import MyTableRow from '../../../widgets/MyTableRow';
import DetailDialog from '../../../widgets/DetailDialog';
import { MyFormattedDate, MyFormattedCurrency } from '../../../intl';
// import ImageThumbnail from '../../../widgets/ImageThumbnail';
import MyAvatar from '../../../widgets/avatar/MyAvatar';

const itemPropTypes = PropTypes.shape({
  thumbnail: PropTypes.string,
  avatar: PropTypes.string,
  text: PropTypes.string,
  number: PropTypes.number,
  currency: PropTypes.number,
  dateMonth: PropTypes.instanceOf(Date),
  date: PropTypes.instanceOf(Date),
  custom: PropTypes.oneOf(['1', '2']),
});

const defaultItemPropTypes = {
  thumbnail: '',
  avatar: '',
  text: '',
  number: 0,
  currency: 0,
  dateMonth: new Date(),
  date: new Date(),
  custom: '1',
};

const SampleCrudDetailDialog = (props) => {
  const {
    open,
    onClose,
    data,
    icons,
  } = props;

  const d = data || defaultItemPropTypes;
  const columns = [
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.avatar',
      content: (
        <MyAvatar
          src={d.avatar}
          name={d.text}
          alt={d.text}
        />
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.thumbnail',
      content: (
        <>
          {
          !d.thumbnail ? '' : (
            // <ImageThumbnail
            //   src={d.thumbnail}
            //   alt={d.text}
            // />
            <ModalImage
              small={d.thumbnail}
              large={d.thumbnail}
              showRotate
              alt={d.text}
            />
          )
        }
        </>
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.text',
      content: (
        <Typography variant="subtitle2">
          {d.text}
        </Typography>
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.number',
      content: (
        <Typography variant="subtitle2">
          <FormattedNumber value={d.number} />
        </Typography>
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.currency',
      content: (
        <Typography variant="subtitle2">
          <MyFormattedCurrency value={d.currency} />
        </Typography>
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.date',
      content: (
        <Typography variant="subtitle2">
          <MyFormattedDate value={new Date(d.date)} />
        </Typography>
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.dateMonth',
      content: (
        <Typography variant="subtitle2">
          <FormattedDate
            value={new Date(d.dateMonth)}
            year="numeric"
            month="long"
          />
        </Typography>
      ),
    },
    {
      type: 'twoColumns',
      labelId: 'seed.crud.sample.table.custom',
      content: (
        <Typography variant="subtitle2" color={d.custom === '1' ? 'primary' : 'error'}>
          {d.custom === '1' ? 'OK' : 'Not OK'}
        </Typography>
      ),
    },
  ];

  return (
    <DetailDialog
      titleId="seed.crud.sample.title.detail"
      open={open}
      onClose={onClose}
      icons={icons}
    >
      <MyTableRow
        columns={columns}
      />
    </DetailDialog>
  );
};

SampleCrudDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  icons: PropTypes.objectOf(PropTypes.object).isRequired,

  data: itemPropTypes,
};

SampleCrudDetailDialog.defaultProps = {
  data: defaultItemPropTypes,
};

export default SampleCrudDetailDialog;
